export default class NewsSearch {
	constructor() {
		this.stateFilter = $('#news-filter-state');
		this.categoryFilter = $('#news-filter .filter-option')
		this.results = $('#news-results');
		this.data = {};
		this.layout = 'grid'; // list, grid
		this.orderby = 'date'; // title, date
		this.order = 'desc';

		// optional data params
		this.pageSize = this.results.data('page-size') || 12;
		this.pagination = this.results.data('pagination') != undefined && this.results.data('pagination') ? 1 : 0;
		this.state = this.results.data('state') || '';

		this.init();
	}

	init() {
		if( ! this.results.length ) return false;

		// preset filters based on hash
		let hash = document.location.hash.replace(/^#/, '').split('/');
		let state = hash[0];
		let category = hash.length > 1 ? hash[1] : '';

		$('option[value="' + state + '"]', this.stateFilter).attr('selected', 'selected');
		var presetCat = this.categoryFilter.filter('[data-term="' + category + '"]');
		if( presetCat.length ) {
			this.categoryFilter.removeClass('active');
			presetCat.addClass('active');
		}

		// search on state filter change
		$(this.stateFilter).on('change', (event) => {
			this.search();
		});

		// search on category filter click
		$(this.categoryFilter).on('click', (event) => {
			event.preventDefault();
			this.categoryFilter.removeClass('active');
			$(event.currentTarget).addClass('active');
			this.search();
		});

		// pagination controls
		$(this.results).on('click', '.page-link', (event) => {
			event.preventDefault();
			var page = $(event.currentTarget).data('page');
			this.search(page);
		});

		// perform initial search
		this.search();
	}

	setHash(states, categories) {
		let state = states && states.length ? states[0] : '';
		let cat = categories && categories.length ? categories[0] : '';

		// don't set if the state is already fixed
		if( ! this.state ) {
			document.location.hash = `${state}/${cat}`;
		}
	}

	search(page=1) {
		// active categories
		var categories = [];
		$(this.categoryFilter).filter('.active').each((n,el)=>{
			categories.push($(el).data('term'));
		});

		// state
		var states = this.state ? [this.state] : [ this.stateFilter.val() ];

		// set location hash to enable someone to bookmark this search
		this.setHash(states, categories);

		// empty the results panel but maintain its height
		var h = $(this.results).height();

		$(this.results)
			.height(h)
			.addClass('loading')
			.prepend('<div class="ajax-results-spinner"><span class="loading-icon fas fa-spinner fa-spin"></span> Loading...</div>');


		$.ajax({
			method: 'post',
			url: window.ff_settings.site_url + '/wp-json/dsa/v1/news?html=1',
			dataType: 'json',
			data: {
				categories: categories.join(','),
				states: states.join(','),
				layout: this.layout,
				orderby: this.orderby,
				order: this.order,
				page_size: this.pageSize,
				pagination: this.pagination,
				// pagination
				page: page
			}
		}).done( (response) => {
			// do something with data
			this.data = response;
			$(this.results)
				.html(response.html)
				.removeClass('loading')
				.removeAttr('style');
		});
	}

	setLayout( layout ) {
		if( ['grid', 'list'].indexOf(layout) >= 0 ) {
			this.layout = layout;
		}
	}

	setOrderBy( field ) {
		if( ['title', 'date'].indexOf(field) >= 0 ) {
			this.orderby = field;
		}

		this.order = this.orderby == 'title' ? 'asc'  : 'desc';
	}
}